import copy from 'copy-text-to-clipboard';

export function initializeCopyToClipboard() {
  document.querySelectorAll('.copy-api-token-btn').forEach(function(btn) {
    // Skip if already initialized
    if (btn.dataset.initialized === 'true') return;
    btn.dataset.initialized = 'true';
    
    btn.addEventListener('click', function() {
      const token = this.getAttribute('data-token');
      const icon = this.querySelector('i');
      const originalIcon = icon.className;
      
      try {
        const success = copy(token);
        
        if (success) {
          // Show success state
          btn.classList.add('copied');
          icon.className = 'fas fa-check';
          btn.setAttribute('title', 'Copied!');
          
          // Reset after 2 seconds
          setTimeout(function() {
            btn.classList.remove('copied');
            icon.className = originalIcon;
            btn.setAttribute('title', 'Copy to clipboard');
          }, 2000);
        } else {
          // Show error state briefly
          btn.classList.add('btn-danger');
          icon.className = 'fas fa-exclamation-triangle';
          btn.setAttribute('title', 'Failed to copy');
          setTimeout(function() {
            btn.classList.remove('btn-danger');
            icon.className = originalIcon;
            btn.setAttribute('title', 'Copy to clipboard');
          }, 2000);
        }
      } catch (err) {
        console.error('Failed to copy:', err);
        // Show error state briefly
        btn.classList.add('btn-danger');
        icon.className = 'fas fa-exclamation-triangle';
        btn.setAttribute('title', 'Failed to copy');
        setTimeout(function() {
          btn.classList.remove('btn-danger');
          icon.className = originalIcon;
          btn.setAttribute('title', 'Copy to clipboard');
        }, 2000);
      }
    });
  });
}

